export default __webpack_public_path__ + "img/btn-excel.abe3bb56.svg";